import { ErrorHandler, Injectable, inject } from '@angular/core';
import rg4js from 'raygun4js';

import packageJson from '../../../package.json';
import { environment } from '../../environments/environment';
import { RaygunService } from './raygun.service';

rg4js('apiKey', environment.logging.apiKey);
rg4js('setVersion', packageJson.version);
rg4js('enableCrashReporting', true);
rg4js('options', {
  excludedHostnames: ['localhost'],
});
rg4js('withTags', ['clux-web', environment.name]);
rg4js('logContentsOfXhrCalls', true);

@Injectable()
export class RaygunErrorHandler implements ErrorHandler {
  private raygunService = inject(RaygunService);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public handleError(e: any): void {
    this.raygunService.logError(e);
  }
}
